// extracted by mini-css-extract-plugin
module.exports = {"fulfillmentSelector":"FulfillmentSelector__fulfillmentSelector___1FoPG","pointer":"FulfillmentSelector__pointer___1UaHI"};